import { create } from 'zustand'
import type { PoiCategory } from '../lib/pois'

export type Panel = 'plan' | 'tours' | 'discover' | 'profile'
export type MapLayer = 'outdoor' | 'topo' | 'satellite'

interface UiState {
  panel: Panel
  /** collapsed = map-first on mobile; the active panel shows as a bottom sheet */
  sheetOpen: boolean
  layer: MapLayer
  terrain3d: boolean
  poiCategories: PoiCategory[]
  toast: string | null
  setPanel: (p: Panel) => void
  setSheetOpen: (open: boolean) => void
  setLayer: (l: MapLayer) => void
  setTerrain3d: (on: boolean) => void
  togglePoiCategory: (c: PoiCategory) => void
  showToast: (msg: string) => void
}

let toastTimer: ReturnType<typeof setTimeout> | undefined

export const useUi = create<UiState>((set, get) => ({
  panel: 'plan',
  sheetOpen: true,
  layer: 'outdoor',
  terrain3d: false,
  poiCategories: [],
  toast: null,
  setPanel: (panel) => set({ panel, sheetOpen: true }),
  setSheetOpen: (sheetOpen) => set({ sheetOpen }),
  setLayer: (layer) => set({ layer }),
  setTerrain3d: (terrain3d) => set({ terrain3d }),
  togglePoiCategory: (c) => {
    const cur = get().poiCategories
    set({ poiCategories: cur.includes(c) ? cur.filter((x) => x !== c) : [...cur, c] })
  },
  showToast: (toast) => {
    clearTimeout(toastTimer)
    set({ toast })
    toastTimer = setTimeout(() => set({ toast: null }), 3500)
  },
}))
